// Bucket labels (Chunk W-Content, 2026-09-26). The schema value 'Related' is
// the pool now called Social Words: standalone words for social posts and the
// social game. The rename is in labels only; the stored value stays 'Related'.
// A Related Word (generated with its Game Word) is a 'Related' word linked
// under a Game Word, shown on the Content tab.
// 2026-10-21 (Odin's ruling): Related and Social Words are retired as a separate
// system. The bucket is "Social only": practice words that run the Game Word
// stages for pre-launch social posts and never go on the calendar or publish.
export const BUCKET_LABEL: Record<string, string> = {
  Game: 'Game',
  Related: 'Social only',
  Bench: 'Bench',
  Rejected: 'Rejected',
};

export function bucketLabel(bucket: string | null | undefined): string {
  if (!bucket) return '';
  return BUCKET_LABEL[bucket] || bucket;
}
